import lf from 'lovefield'

export function const_famillesengins_const_options_const_phases (schemaBuilder) {
  schemaBuilder.createTable('const_famillesengins_const_options_const_phases')
      .addColumn('id', lf.Type.INTEGER)
      .addColumn('const_famillesengins_id', lf.Type.STRING)
      .addColumn('const_options_id', lf.Type.STRING)
      .addColumn('const_phases_id', lf.Type.STRING)
      .addPrimaryKey(['id'])
      // .addUnique('constFamillesengins_id', ['constFamillesengins_id', 'constOptions_id', 'constPhases_id'])
}


/*

CREATE TABLE IF NOT EXISTS `const-famillesengins_const-options_const-phases` (
  `id` int(11) NOT NULL AUTO_INCREMENT,
  `const-famillesengins_id` int(11) NOT NULL,
  `const-options_id` int(11) NOT NULL DEFAULT '1',
  `const-phases_id` int(11) NOT NULL,
  PRIMARY KEY (`id`),
  UNIQUE KEY `const-famillesengins_id` (`const-famillesengins_id`,`const-options_id`,`const-phases_id`)
) ENGINE=InnoDB  DEFAULT CHARSET=utf8 AUTO_INCREMENT=27 ;

*/



// WEBPACK FOOTER //
// ./src/client/common/db/schemas/constFamillesengins_constOptions_constPhases.schema.js